export const SCHOOL_LINK_STATUS_LINKED = 0
export const SCHOOL_LINK_STATUS_OPERATING = SCHOOL_LINK_STATUS_LINKED
export const SCHOOL_LINK_STATUS_STOPPED = 1
export const SCHOOL_LINK_STATUS_NOT_LINKED = 2

export const SCHOOL_DISPLAY_STATUS_VISIBLE = 0
export const SCHOOL_DISPLAY_STATUS_HIDDEN = 1

export const SCHOOL_TYPE_SECONDARY = 1
export const SCHOOL_TYPE_HIGH_SCHOOL = 2
export const SCHOOL_TYPE_UNIVERSITY = 3
export const SCHOOL_TYPE_INTER_LEVEL = 4
export const SCHOOL_TYPE_COLLEGE = 5
export const SCHOOL_TYPE_CONTINUING_EDUCATION = 6
export const SCHOOL_TYPE_VOCATIONAL_INTERMEDIATE = 7
export const SCHOOL_TYPE_PRIMARY = 8
export const SCHOOL_TYPE_VOCATIONAL_EDUCATION = 9
export const SCHOOL_TYPE_VOCATIONAL_AND_CONTINUING_EDUCATION = 10
export const SCHOOL_TYPE_PARTY_SCHOOL = 11

export const SCHOOL_CLASSIFICATION_PUBLIC = 1
export const SCHOOL_CLASSIFICATION_PRIVATE_PEOPLE_FUNDED = 2
export const SCHOOL_CLASSIFICATION_PRIVATE = 3

export const StatusSchool = [
    {
        name: 'Đã liên kết',
        value: SCHOOL_LINK_STATUS_LINKED
    },
    {
        name: 'Ngừng liên kết',
        value: SCHOOL_LINK_STATUS_STOPPED
    },
    {
        name: 'Chưa liên kết',
        value: SCHOOL_LINK_STATUS_NOT_LINKED
    }
]

export const DisplaySchool = [
    {
        name: 'Hiển thị',
        value: SCHOOL_DISPLAY_STATUS_VISIBLE
    },
    {
        name: 'Ẩn',
        value: SCHOOL_DISPLAY_STATUS_HIDDEN
    }
]

export const SchoolType = [
    {
        name: 'Trung học cơ sở',
        value: SCHOOL_TYPE_SECONDARY
    },
    {
        name: 'Trung học phổ thông',
        value: SCHOOL_TYPE_HIGH_SCHOOL
    },
    {
        name: 'Đại học',
        value: SCHOOL_TYPE_UNIVERSITY
    },
    {
        name: 'Liên cấp',
        value: SCHOOL_TYPE_INTER_LEVEL
    },
    {
        name: 'Cao đẳng',
        value: SCHOOL_TYPE_COLLEGE
    },
    {
        name: 'Giáo dục thường xuyên',
        value: SCHOOL_TYPE_CONTINUING_EDUCATION
    },
    {
        name: 'Trung cấp nghề',
        value: SCHOOL_TYPE_VOCATIONAL_INTERMEDIATE
    },
    {
        name: 'Tiểu học',
        value: SCHOOL_TYPE_PRIMARY
    },
    {
        name: 'Giáo dục nghề nghiệp',
        value: SCHOOL_TYPE_VOCATIONAL_EDUCATION
    },
    {
        name: 'Giáo dục nghề nghiệp và Giáo dục thường xuyên',
        value: SCHOOL_TYPE_VOCATIONAL_AND_CONTINUING_EDUCATION
    },
    {
        name: 'Trường Đảng',
        value: SCHOOL_TYPE_PARTY_SCHOOL
    }
]

export const SchoolClassification = [
    {
        name: 'Công lập',
        value: SCHOOL_CLASSIFICATION_PUBLIC
    },
    {
        name: 'Dân lập',
        value: SCHOOL_CLASSIFICATION_PRIVATE_PEOPLE_FUNDED
    },
    {
        name: 'Tư thục',
        value: SCHOOL_CLASSIFICATION_PRIVATE
    }
]
